import Vue from 'vue'
import Vuex from 'vuex'
import Print from 'vue-print-nb'
import XEUtils from 'xe-utils'
import * as echarts from 'echarts'

// style
import './assets/fonts/iconfont.css'
import 'element-ui/lib/theme-chalk/index.css'
import 'vxe-table/lib/style.css'
import 'vxe-table-plugin-element/dist/style.css'
import './assets/styles/element-ui.less'
import './assets/styles/vxe-table.less'
import './assets/styles/common.less'
import './assets/styles/global.less'

import App from './App.vue'
import router from './router'
import api from './api'
import store from './store'
import util from './utils/util'
import tool from './utils/tool'
import constant from './utils/constant'
import components from '@/components/index'
import debounceDirective from './directives/debounce'

// 全局配置config
Vue.config.productionTip = false
Vue.config.devtools = true

// 注册为全局指令
Vue.directive('debounce', debounceDirective)

// 全局引入插件
Vue.use(Vuex)
Vue.use(Print)

// element-ui
import ElementUI from 'element-ui'
import locale from 'element-ui/lib/locale/lang/zh-CN'
Vue.use(ElementUI, { locale })

// vex-table
import VXETable from 'vxe-table'
import VXETablePluginElement from 'vxe-table-plugin-element'
import VXETablePluginExportXLSX from 'vxe-table-plugin-export-xlsx'
import ExcelJS from 'exceljs'
Vue.use(VXETable)
VXETable.use(VXETablePluginElement)
VXETable.use(VXETablePluginExportXLSX, { ExcelJS })
VXETable.setConfig({
  grid: {
    size: 'mini' // 尺寸
  },
  table: {
    border: true, // 边框
    align: 'center', // 居中
    // stripe: true, // 斑马纹
    showOverflow: false, // 内容不换行，超出省略号 tooltip
    columnConfig: {
      resizable: true // 列宽调整
    },
    rowConfig: {
      isHover: true, // 鼠标经过
      isCurrent: true, // 选中高亮
      useKey: true // 是否需要为每一列的 VNode 设置 key 属性，keyField指定key字段，默认为index索引
    }

    // 以下暂不使用
    // checkboxConfig: {
    //   labelField: 'id', // 复选框显示的字段名，可以直接显示在复选框后面 生效
    //   range: true // 开启复选框范围选择功能（启用后通过鼠标在复选框的列内滑动选中或取消指定行）不生效
    // }
    // data: [],
    // columns: [],
    // height: '',
  }
})

// 全局引入方法 this.$xxx
Vue.prototype.$api = api // 接口
Vue.prototype.$XEUtils = XEUtils // 工具
Vue.prototype.$XModal = VXETable.modal // 模态框
Vue.prototype.$util = util // 方法-公用
Vue.prototype.$tool = tool // 方法-业务
Vue.prototype.$constant = constant // 常量
Vue.prototype.$echarts = echarts // 图表

components(Vue)

new Vue({
  router,
  store,
  render: (h) => h(App)
}).$mount('#app')
